import { N12_01 } from "./N12_01";

export const N12 = {
    "columns": 4,
    "rows": 1,
    "visual": {
        "id": 1,
        "type": "advancedGauge",
        "colorTheme": 'colorTheme1',
        "title": "CALL RATE",
        "orientation": "vertical",
        "xAxis": "",
        "yAxis": "",
        "binding": {
            "data": {
                "title": "Title",
                "value": 'Progress',
                "total": 'Total',
                "endpoint": "N12",
                "parameters": [
                    { key: "CycleCode", value: "CP1" },
                    { key: "CycleYear", value: "2026" },
                ]
            },
            "context": {
                "point": {
                    "onClick": N12_01
                }
            }
        }
    }
}